import { React, useState, useEffect, useRef, useContext } from "react";
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid } from '@mui/x-data-grid';
import PCSelectModal from "../PCSelectModal";

function ItemSelectModal({ title, onClose, nowIOType, upperPartnerId, handleInputItemClick }) {
  const appStore = useContext(AppContext);
  const searchRef = useRef(null);
  const isTabletDevice = localStorage.getItem("deviceType") === "T";
  const [keyword, setKeyword] = useState('');
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
    item_version_seq: false,
    item_max_version_seq: false,
    item_name: true,
    item_spec: true,
    item_type_name: true,
    item_division_name: false,
    item_width: !isTabletDevice,
    item_depth: !isTabletDevice,
    item_height: !isTabletDevice,
    item_stock: false,
    item_dp_stock: false,
    item_use_stock: false,
    item_dp_use_stock: true,
    item_stock_price_currency: false,
    item_stock_price: false,
    item_save_workplace_id: false,
    item_save_warehouse_id: false,
    item_save_section_id: false,
    item_save_workplace_name: false,
    item_save_warehouse_name: false,
    item_save_section_name: false,
    // ▼ 포장비율 4종 숨김 (값만 넘기기 위함)
    item_order_package_count: false,
    item_incoming_package_count: false,
    item_purchase_package_count: false,
    item_outgoing_package_count: false
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    searchRef.current.focus();
    handleSetting();
    handleView();
    setColumnVisibilityModel({
      id: false,
      item_version_seq: false,
      item_max_version_seq: false,
      item_name: true,
      item_spec: true,
      item_type_name: true,
      item_division_name: false,
      item_width: !isTabletDevice,
      item_depth: !isTabletDevice,
      item_height: !isTabletDevice,
      item_stock_price_currency: false,
      item_stock_price: false,
      item_stock: false,
      item_dp_stock: false,
      item_use_stock: false,
      item_dp_use_stock: true,
      item_save_workplace_id: false,
      item_save_warehouse_id: false,
      item_save_section_id: false,
      item_save_workplace_name: false,
      item_save_warehouse_name: false,
      item_save_section_name: false,
      item_order_package_count: false,
      item_incoming_package_count: false,
      item_purchase_package_count: false,
      item_outgoing_package_count: false
    });
  }, []);


  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  const onSubmitSearch = (e) => {
    //입력 검색어는 Enter로 조회.
    if (e.key === "Enter") {
      handleView();
    }
  };
  
  const handleSetting = () => {
    setColumns([
      { field: 'id', headerName: 'item_id', width: 0, headerAlign: 'center' },
      { field: 'item_version_seq', headerName: 'item_version_seq', width: 0, headerAlign: 'center' },
      { field: 'item_max_version_seq', headerName: 'item_max_version_seq', width: 0, headerAlign: 'center' },
      { field: 'item_name', headerName: '품목', width: isTabletDevice ? 250 : 200, headerAlign: 'center' },
      { field: 'item_spec', headerName: '규격', width: 100, headerAlign: 'center' },
      { field: 'item_type_name', headerName: '유형', width: 110, headerAlign: 'center', align:'center' },
      { field: 'item_division_name', headerName: '분류', width: 110, headerAlign: 'center', align:'center' },
      { field: 'item_dp_use_stock', headerName: '재고', width: 100, headerAlign: 'center', align:'right' },
      { field: 'item_width', headerName: '가로', width: 90, headerAlign: 'center', align:'right' },
      { field: 'item_depth', headerName: '세로', width: 90, headerAlign: 'center', align:'right' },
      { field: 'item_height', headerName: '높이', width: 90, headerAlign: 'center', align:'right' },
      { field: 'item_stock_price_currency', headerName: '통화단위', width: 0, headerAlign: 'center', align:'right' },
      { field: 'item_stock_price', headerName: '금액', width: 0, headerAlign: 'center', align:'right' },
      { field: 'item_stock', headerName: 'item_stock', width: 0, headerAlign: 'center', align:'right' },
      { field: 'item_dp_stock', headerName: 'item_dp_stock', width: 0, headerAlign: 'center', align:'right' },
      { field: 'item_use_stock', headerName: 'item_use_stock', width: 0, headerAlign: 'center', align:'right' },
      { field: 'item_save_workplace_id', headerName: 'item_save_workplace_id', width: 0, headerAlign: 'center', align:'center' },
      { field: 'item_save_warehouse_id', headerName: 'item_save_warehouse_id', width: 0, headerAlign: 'center', align:'center' },
      { field: 'item_save_section_id', headerName: 'item_save_section_id', width: 0, headerAlign: 'center', align:'center' },
      { field: 'item_save_workplace_name', headerName: 'item_save_workplace_name', width: 0, headerAlign: 'center', align:'center' },
      { field: 'item_save_warehouse_name', headerName: 'item_save_warehouse_name', width: 0, headerAlign: 'center', align:'center' },
      { field: 'item_save_section_name', headerName: 'item_save_section_name', width: 0, headerAlign: 'center', align:'center' },
      // ▼ 컬럼 매핑 추가
      { field: 'item_order_package_count', headerName: 'item_order_package_count', width: 0, headerAlign: 'center', align:'center' },
      { field: 'item_incoming_package_count', headerName: 'item_incoming_package_count', width: 0, headerAlign: 'center', align:'center' },
      { field: 'item_purchase_package_count', headerName: 'item_purchase_package_count', width: 0, headerAlign: 'center', align:'center' },
      { field: 'item_outgoing_package_count', headerName: 'item_outgoing_package_count', width: 0, headerAlign: 'center', align:'center' },
    ]);
  }

  const handleView = () => {
    setRows([]);
    axios.get('/api/SelectCommon/ItemList',
        {
        params : {
          keyword: keyword
        }
      },
      { withCredentials: true }
    )
    .then((response) => {
      var new_array = [];
      var array = response.data.map((item, index) => ({
        id: item.item_id,
        item_version_seq:item.item_version_seq,
        item_max_version_seq:item.item_max_version_seq,
        item_name: item.item_name,
        item_spec: item.item_spec,
        item_type_name: item.item_type_name,
        item_division_name: item.item_division_name,
        item_width: item.item_width,
        item_depth: item.item_depth,
        item_height: item.item_height,
        item_stock_price_currency: item.item_stock_price_currency,
        item_stock_price: item.item_stock_price,
        item_stock: item.stock,
        item_dp_stock: item.dp_stock,
        item_use_stock: item.use_stock,
        item_dp_use_stock: item.dp_use_stock,
        item_in_out_type: item.item_in_out_type,
        item_partner_seq: item.item_partner_seq,
        main_partner_yn: item.main_partner_yn,
        item_partner_price: item.item_partner_price,
        item_partner_price_currency: item.item_partner_price_currency,
        partner_id: item.partner_id,
        item_save_workplace_id: item.item_save_workplace_id,
        item_save_warehouse_id: item.item_save_warehouse_id,
        item_save_section_id: item.item_save_section_id,
        item_save_workplace_name: item.item_save_workplace_name,
        item_save_warehouse_name: item.item_save_warehouse_name,
        item_save_section_name: item.item_save_section_name,
        // ▼ 포장비율 4종 매핑
        item_order_package_count: item.item_order_package_count,
        item_incoming_package_count: item.item_incoming_package_count,
        item_purchase_package_count: item.item_purchase_package_count,
        item_outgoing_package_count: item.item_outgoing_package_count
      }));
      array = array.filter((element) => element.item_id === element.item_id && element.item_version_seq === element.item_max_version_seq);

      var now_id = 0;
      var now_seq = 0;
      var main_exi_yn = 'N'
      for(let i = 0; i < array.length; i++){
        
        if (array[i].partner_id === upperPartnerId && array[i].item_in_out_type === nowIOType) {

          new_array = new_array.filter((data) => data.id !== array[i].id);
          new_array.push({
            id: array[i].id,
            item_version_seq:array[i].item_version_seq,
            item_max_version_seq:array[i].item_max_version_seq,
            item_name: array[i].item_name,
            item_spec: array[i].item_spec,
            item_type_name: array[i].item_type_name,
            item_division_name: array[i].item_division_name,
            item_width: array[i].item_width,
            item_depth: array[i].item_depth,
            item_height: array[i].item_height,
            item_stock_price_currency: array[i].item_partner_price_currency,
            item_stock_price: array[i].item_partner_price,
            item_stock: array[i].item_stock,
            item_dp_stock: array[i].item_dp_stock,
            item_use_stock: array[i].item_use_stock,
            item_dp_use_stock: array[i].item_dp_use_stock,
            item_in_out_type: array[i].item_in_out_type,
            item_partner_seq: array[i].item_partner_seq,
            main_partner_yn: array[i].main_partner_yn,
            item_partner_price: array[i].item_partner_price,
            item_partner_price_currency: array[i].item_partner_price_currency,
            partner_id: array[i].partner_id,
            item_save_workplace_id: array[i].item_save_workplace_id,
            item_save_warehouse_id: array[i].item_save_warehouse_id,
            item_save_section_id: array[i].item_save_section_id,
            item_save_workplace_name: array[i].item_save_workplace_name,
            item_save_warehouse_name: array[i].item_save_warehouse_name,
            item_save_section_name: array[i].item_save_section_name,
            // ▼ 포장비율
            item_order_package_count: array[i].item_order_package_count,
            item_incoming_package_count: array[i].item_incoming_package_count,
            item_purchase_package_count: array[i].item_purchase_package_count,
            item_outgoing_package_count: array[i].item_outgoing_package_count
          });

        } else if (now_id !== array[i].id) {

          new_array.push({
            id: array[i].id,
            item_version_seq:array[i].item_version_seq,
            item_max_version_seq:array[i].item_max_version_seq,
            item_name: array[i].item_name,
            item_spec: array[i].item_spec,
            item_type_name: array[i].item_type_name,
            item_division_name: array[i].item_division_name,
            item_width: array[i].item_width,
            item_depth: array[i].item_depth,
            item_height: array[i].item_height,
            item_stock_price_currency: 144,
            item_stock_price: array[i].item_stock_price,
            item_in_out_type: array[i].item_in_out_type,
            item_partner_seq: array[i].item_partner_seq,
            main_partner_yn: array[i].main_partner_yn,
            item_partner_price: array[i].item_partner_price,
            item_stock: array[i].item_stock,
            item_dp_stock: array[i].item_dp_stock,
            item_use_stock: array[i].item_use_stock,
            item_dp_use_stock: array[i].item_dp_use_stock,
            item_partner_price_currency: array[i].item_partner_price_currency,
            partner_id: array[i].partner_id,
            item_save_workplace_id: array[i].item_save_workplace_id,
            item_save_warehouse_id: array[i].item_save_warehouse_id,
            item_save_section_id: array[i].item_save_section_id,
            item_save_workplace_name: array[i].item_save_workplace_name,
            item_save_warehouse_name: array[i].item_save_warehouse_name,
            item_save_section_name: array[i].item_save_section_name,
            // ▼ 포장비율
            item_order_package_count: array[i].item_order_package_count,
            item_incoming_package_count: array[i].item_incoming_package_count,
            item_purchase_package_count: array[i].item_purchase_package_count,
            item_outgoing_package_count: array[i].item_outgoing_package_count
          });
        }

        now_id = array[i].id
        now_seq = array[i].item_partner_seq
      }
      setRows(new_array);
    })
    .catch((error) => {
        appStore.capture();
    });
  };

  const handleRowClick = (params) => {
    handleInputItemClick(params.row);
    onClose?.();
  };

  const handleDelete = () => {
    handleInputItemClick({
      id : '',
      item_version_seq: '',
      item_max_version_seq: '',
      item_name: '',
      item_spec: '',
      item_type_name: '',
      item_division_name: '',
      item_width: '',
      item_depth: '',
      item_height: '',
      item_stock_price_currency: '',
      item_stock_price: '',
      item_stock: '',
      item_dp_stock: '',
      item_use_stock: '',
      item_dp_use_stock: '',
      item_save_workplace_id: '',
      item_save_warehouse_id: '',
      item_save_section_id: '',
      item_save_workplace_name: '',
      item_save_warehouse_name: '',
      item_save_section_name: '',
      item_order_package_count: 1,
      item_incoming_package_count: 1,
      item_purchase_package_count: 1,
      item_outgoing_package_count: 1
    });
    onClose?.();
  };

  return (
    <PCSelectModal onClose={onClose} title={title}>
        <div className="modal" style={{ maxHeight : '435px' }}>
          <table className="SelectModalTABLE">
            <tbody>
            <tr>
              <td className="SelectModalTD" colSpan={2} style={ { padding: '5px' } }>
                <div className="modal_filed_input" style={ { width: 'calc(100% - 190px)', float: 'left' } }>
                  <input type="text" placeholder="검색" value={keyword} name="keyword" onChange={(e) => setKeyword(e.target.value) } onKeyPress={onSubmitSearch} ref={searchRef} autoComplete="off" />
                </div>
                
                <div className="modal_filed_input" style={ { float: 'right' } }>
                  <Button 
                    onClick={handleView}
                    className="btn-p btn-m"
                    sx={{  
                        m: 1, 
                        fontSize: 12, 
                        color: "white", 
                        borderColor: "#3D63AE", 
                        backgroundColor: "#3D63AE",
                        margin: '0px',
                        ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                    }} 
                    variant="outlined">
                    조회
                  </Button>
                </div>
                <div className="modal_filed_input" style={ { float: 'right', paddingRight: '8px' } }>
                  <Button 
                    onClick={handleDelete}
                    className="btn-p btn-m"
                    sx={{  
                        m: 1, 
                        fontSize: 12, 
                        color: "white", 
                        borderColor: "#FF3636", 
                        backgroundColor: "#FF3636",
                        margin: '0px',
                        ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                    }} 
                    variant="outlined">
                    삭제
                  </Button>
                </div>
              </td>
            </tr>
            <tr>
              <td className="SelectModalTD" colSpan={2}>
                <div style={{ padding: '5px', height: '300px' }}>
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    columnVisibilityModel={columnVisibilityModel}
                    onProcessRowUpdateError={(error) => error}
                    AlternatingRowBackground="LavenderBlush"
                    rowsPerPageOptions={[20, 50, 100]}
                    onRowClick={handleRowClick}
                    initialState={{ 
                        density: 'compact'
                    }}
                    slots={{
                        noRowsOverlay: GridNoRow,
                    }}
                    sx={{
                      cursor: "pointer"
                    }}      
                    disableColumnSorting 
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td className="SelectModalTD" colSpan={2}>
                <div className="select_modal_action">
                  <div className="select_modal_button">
                    <Button 
                      onClick={()=> { onClose?.(); }}
                      className="btn-p btn-m"
                      sx={{  
                          m: 1, 
                          fontSize: 12, 
                          color: "white", 
                          borderColor: "#808080", 
                          backgroundColor: "#808080",
                          ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                      }} 
                      variant="outlined">
                      닫기
                    </Button>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
    </PCSelectModal>
  );
}

export default ItemSelectModal;